import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const FaceSmileIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm6.108-.542a.904.904 0 1 0 0-1.807.904.904 0 0 0 0 1.807Zm6.687-.904a.904.904 0 1 1-1.807 0 .904.904 0 0 1 1.807 0Zm-6.687 2.65c.4 0 .723.324.723.724 0 .162.12.45.534.735.396.272.974.47 1.635.47.66 0 1.24-.198 1.635-.47.414-.284.534-.572.534-.735a.723.723 0 1 1 1.445 0c0 .816-.527 1.491-1.16 1.926-.65.448-1.518.724-2.454.724-.936 0-1.803-.276-2.454-.723-.633-.436-1.16-1.111-1.16-1.927 0-.4.323-.723.722-.723Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M9.108 11.458a.904.904 0 1 0 0-1.807.904.904 0 0 0 0 1.807ZM15.795 10.554a.904.904 0 1 1-1.807 0 .904.904 0 0 1 1.807 0ZM9.831 13.928a.723.723 0 0 0-1.445 0c0 .816.527 1.491 1.16 1.926.65.448 1.518.724 2.454.724.936 0 1.803-.276 2.454-.724.633-.434 1.16-1.11 1.16-1.926a.723.723 0 0 0-1.445 0c0 .162-.12.45-.534.735-.396.272-.974.47-1.635.47-.66 0-1.24-.198-1.635-.47-.414-.284-.534-.572-.534-.735Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7.265 9a7.265 7.265 0 1 1 14.53 0 7.265 7.265 0 0 1-14.53 0Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `FaceSmileIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { FaceSmileIcon };
//# sourceMappingURL=FaceSmileIcon.mjs.map
